export default __webpack_public_path__ + "static/media/mons18.434d8deb.jpg";